import CrossSvg from "$assets/icons/cross.svg?icon";
import type { ComponentProps } from "react";

// Defaults to white; callers can recolour via the legacy `fill` prop.
const CrossIcon = ({ fill, ...props }: ComponentProps<typeof CrossSvg>) => (
  <CrossSvg htmlColor={(fill as string | undefined) ?? "#fff"} {...props} />
);

export default CrossIcon;
